import { render, staticRenderFns } from "./TwoFactorAuthenticationCard.vue?vue&type=template&id=552187d0"
import script from "./TwoFactorAuthenticationCard.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationCard.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationCard.vue?vue&type=style&index=0&id=552187d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports